/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_New_Message_BtnInputs */

const tr_contact_form_new_message_btn = /** @type {(inputs: Contact_Form_New_Message_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni mesaj yaz`)
};

const en_contact_form_new_message_btn = /** @type {(inputs: Contact_Form_New_Message_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write new message`)
};

const de_contact_form_new_message_btn = /** @type {(inputs: Contact_Form_New_Message_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Nachricht schreiben`)
};

const ru_contact_form_new_message_btn = /** @type {(inputs: Contact_Form_New_Message_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Написать новое сообщение`)
};

/**
* | output |
* | --- |
* | "Write new message" |
*
* @param {Contact_Form_New_Message_BtnInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_new_message_btn = /** @type {((inputs?: Contact_Form_New_Message_BtnInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_New_Message_BtnInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_new_message_btn(inputs)
	if (locale === "de") return de_contact_form_new_message_btn(inputs)
	if (locale === "ru") return ru_contact_form_new_message_btn(inputs)
	return tr_contact_form_new_message_btn(inputs)
});